import * as React from 'react';
import styled from 'styled-components';
import { PAGE_GUTTER } from './consts';

const ContainerWithGutter = styled.div`
  margin-left: auto;
  margin-right: auto;

  padding-left: ${PAGE_GUTTER};
  padding-right: ${PAGE_GUTTER};

  width: 100%;
  box-sizing: border-box;
`;

export const withGutters = (Component) => (props) => (
  <ContainerWithGutter>
    <Component {...props} />
  </ContainerWithGutter>
);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/containers/withGutters.tsx